import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { Link } from "react-router-dom";
import Select from "react-select";
import { IndexUse } from "./IndexUse";
import { IDS } from "../../../../utils/IDS";
import {
  GetSingle,
  Update,
  Create,
} from "../../../../features/admin/user-management/user/Slice";
import { useDispatch, useSelector } from "react-redux";
import classNames from "classnames";
import { Controller, useForm } from "react-hook-form";
import { GetAll } from "../../../../features/admin/role-management/role/Slice";
import PasswordChecklist from "react-password-checklist";
import Successfull_Modal from "../../../common-components/common_Modal/Successfull_Modal/Successfull_Modal";
import { getAllRoles } from "../../../../features/admin/common/Slice";
import Add_section_title from "../../../common-components/add-section-title/Add_section_title";

const Add = ({ id, setId, setShowError, setSuccess, setErr }) => {
  const { fetch } = IndexUse();
  const dispatch = useDispatch();

  const roles = useSelector((state) => state?.common?.all_roles);

  const [password, setPassword] = useState("");

  console.log(roles, "roles");
  const [modalShow, setModalShow] = React.useState(false);

  const {
    register,
    handleSubmit,
    clearErrors,
    setValue,
    getValues,
    setError,
    control,
    watch,
    formState: { errors },
    reset,
    image_required = true,
  } = useForm();

  const confirmPassword = watch("confirm_password");
  const imageFile = watch("image");

  const GetData = async (id) => {
    try {
      const res = await dispatch(GetSingle(id));

      if (res.meta.requestStatus === "fulfilled") {
        const { password, ...rest } = res?.payload?.data || {};
        reset(rest);

        // ✅ force clear password fields after reset
        setValue("password", "");
        setValue("confirm_password", "");
        setPassword("");
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    if (id !== "") {
      GetData(id);
    }
  }, [id]);

  const onSubmit = async (data) => {
    try {
      const sendData = new FormData();
      sendData.append("first_name", data?.first_name);
      sendData.append("last_name", data?.last_name);
      sendData.append("email", data?.email);
      sendData.append("contact_no", data?.contact_no);
      sendData.append("role_id", data?.role_id);
      sendData.append("password", data?.password);
      // sendData.append("message", data?.message);
      // sendData.append("description", data?.description);
      // sendData.append("image", data?.image[0]);
      let response;
      if (id) {
        response = await dispatch(Update({ id: id, data: sendData }));
      } else {
        response = await dispatch(Create(sendData));
      }
      if (response.meta.requestStatus === "fulfilled") {
        await fetch();

        setId("");

        reset({
          first_name: "",
          last_name: "",
          email: "",
          contact_no: "",
          role_id: "",
          password: "",
          confirm_password: "",
        });

        setPassword("");

        clearErrors();

        setModalShow(true);

        setTimeout(() => {
          setModalShow(false);
        }, 3000);
      } else if (response.meta?.requestStatus === "rejected") {
        setShowError(response.payload?.response?.data?.errors);
      }

      if (response.payload == 406) {
        await setError("contact_no", {
          type: "manual",
          message: "Contact Number Already Exists",
        });
      }
      if (response.payload == 405) {
        await setError("email", {
          type: "manual",
          message: "Email Already Exists",
        });
      }
    } catch (error) {
      console.error("error in Add Namee", error);
    }
  };

  const getRoles = async () => {
    const res = await dispatch(getAllRoles());
  };

  useEffect(() => {
    getRoles();
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);

    if (id !== "") {
      GetData(id);

      // ✅ reset only password fields
      setValue("password", "");
      setValue("confirm_password", "");
      setPassword("");
    }
  }, [id]);

  return (
    <>
      <Add_section_title title={id ? "Edit Users" : "Add Users"} alltotal="" />
      <div className="forms_section">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <div className="row">
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>First Name</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  className={classNames("", {
                    "is-invalid": errors?.first_name,
                  })}
                  {...register("first_name", {
                    required: "First Name is Required",

                    pattern: {
                      value: /^[A-Za-z]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                />
                {errors.first_name && (
                  <span className="text-danger">
                    {errors.first_name?.message}
                  </span>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Last Name</Form.Label>
                <Form.Control
                  type="text"
                  name=""
                  placeholder="Last Name"
                  {...register("last_name", {
                    required: "Last Name is Required",
                    pattern: {
                      value: /^[A-Za-z]+$/,
                      message: "Only alphabets are allowed",
                    },
                  })}
                  className={classNames("", {
                    "is-invalid": errors?.name,
                  })}
                />
                {errors.last_name && (
                  <span className="text-danger">
                    {errors.last_name?.message}
                  </span>
                )}
              </Form.Group>
            </div>
            <div className="col-lg-6 col-md-6 mb-3">
              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Email"
                  className={classNames("", { "is-invalid": errors?.email })}
                  {...register("email", {
                    required: "Email is required",

                    pattern: {
                      value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                      message: "Enter a valid email address",
                    },

                    maxLength: {
                      value: 100,
                      message: "Email cannot exceed 100 characters",
                    },
                  })}
                />
                {errors?.email && (
                  <Form.Text className="text-danger">
                    {errors?.email?.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicName">
                <Form.Label>Contact No</Form.Label>

                <Form.Control
                  type="text"
                  maxLength={10}
                  placeholder="Enter Contact No"
                  className={classNames("", {
                    "is-invalid": errors?.contact_no,
                  })}
                  {...register("contact_no", {
                    required: "Contact number is required",
                    pattern: {
                      value: /^[0-9]{10}$/,
                      message: "Contact number must be exactly 10 digits",
                    },
                  })}
                />

                {errors?.contact_no && (
                  <Form.Text className="text-danger">
                    {errors?.contact_no?.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            {roles?.length > 0 && (
              <div className="col-lg-6 col-md-6 mb-3">
                <Form.Group className="mb-3" controlId="formBasicRole">
                  <Form.Label>Role</Form.Label>

                  <Controller
                    name="role_id"
                    control={control}
                    rules={{ required: "Role is required" }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={roles}
                        placeholder="Select Role"
                        className={classNames("", {
                          "is-invalid": errors?.role_id,
                        })}
                        onChange={(selected) => field.onChange(selected?.value)}
                        value={
                          roles.find((opt) => opt.value === field.value) || null
                        }
                      />
                    )}
                  />

                  {errors.role_id && (
                    <span className="text-danger">
                      {errors.role_id?.message}
                    </span>
                  )}
                </Form.Group>
              </div>
            )}
            <div className="col-lg-6 col-md-6 mb-3">
              {/* Password */}
              <Form.Group className="mb-3" controlId="formBasicPassword">
                <Form.Label>Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter Password"
                  className={classNames("", { "is-invalid": errors?.password })}
                  {...register("password", {
                    required: id ? false : "Password is required",
                    minLength: id
                      ? undefined
                      : {
                          value: 8,
                          message: "Password must be at least 8 characters",
                        },
                  })}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {errors?.password && (
                  <Form.Text className="text-danger">
                    {errors.password.message}
                  </Form.Text>
                )}
              </Form.Group>

              <Form.Group className="mb-3" controlId="formBasicConfirmPassword">
                <Form.Label>Confirm Password</Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Confirm Password"
                  className={classNames("", {
                    "is-invalid": errors?.confirm_password,
                  })}
                  {...register("confirm_password", {
                    required: id ? false : "Confirm Password is required",
                    validate: (value) => {
                      if (!id && value !== password)
                        return "Passwords do not match";
                      return true;
                    },
                  })}
                />
                {errors?.confirm_password && (
                  <Form.Text className="text-danger">
                    {errors.confirm_password.message}
                  </Form.Text>
                )}
              </Form.Group>

              {/* Password Checklist */}
              <PasswordChecklist
                rules={["minLength", "number", "capital", "special", "match"]}
                minLength={8}
                value={password}
                valueAgain={confirmPassword}
                onChange={(isValid) => console.log("Password valid:", isValid)}
              />
            </div>
          </div>

          <div className="form_submit_div ">
            <div className="row">
              <div className="col-lg-4 mx-auto mb-3">
                <div className="button_group">
                  <button
                    type="button"
                    className="closebtn theme_bg"
                    onClick={() => {
                      reset({
                        first_name: "",
                        last_name: "",
                        email: "",
                        contact_no: "",
                        role_id: "",
                        password: "",
                        confirm_password: "",
                      });

                      setPassword("");

                      clearErrors();

                      setId("");
                    }}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="addbtn"
                    onClick={handleSubmit(onSubmit)}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Form>
      </div>

      <Successfull_Modal
        message={"Successful"}
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
};

export default Add;
